import React from 'react';
import './Portfolio.css';

const projects = [
    {
        id: 1,
        title: "Xyrons Community Hub",
        category: "Web Development",
        desc: "Platform pusat komunitas Xyrons berbasis React dengan fitur integrasi artikel dan portofolio.",
        tech: ["React JS", "Framer Motion", "CSS Modules"]
    },
    {
        id: 2,
        title: "Xyrons Ecosystem Design",
        category: "UI/UX Design",
        desc: "Perancangan antarmuka futuristik untuk seluruh ekosistem digital Xyrons.",
        tech: ["Figma", "Adobe Illustrator"]
    },
    {
        id: 3,
        title: "Xyrons AI Assistant",
        category: "Artificial Intelligence",
        desc: "Implementasi kecerdasan buatan untuk membantu interaksi anggota di dalam hub Xyrons.",
        tech: ["Node.js", "Gemini API"]
    }
];

export default function Portfolio() {
    return (
        <div className="portfolio-page-container">
            <header className="portfolio-header">
                <h2 className="portfolio-main-title">XYRONS PROJECTS</h2>
                <p className="portfolio-subtitle">KARYA DAN KONTRIBUSI TERBAIK DALAM EKOSISTEM XYRONS.</p>
            </header>

            <div className="portfolio-grid">
                {projects.map((project) => (
                    <div key={project.id} className="portfolio-card">
                        <div className="portfolio-content">
                            <span className="portfolio-category">{project.category}</span>
                            <h3 className="project-title">{project.title}</h3>
                            <p className="project-desc">{project.desc}</p>

                            <div className="project-tech-stack">
                                {project.tech.map((t, index) => (
                                    <span key={index} className="tech-tag">{t}</span>
                                ))}
                            </div>

                            <a href="#" className="project-link">View Project →</a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}